import { memo } from 'react';

import { useWebPushListeners } from '@/features/notifications/hooks/useWebPushListeners';

/**
 * Handler for web push notification clicks via postMessage from service worker
 * Service worker sends postMessage when navigate() is not supported
 */
export const WebPushNotificationHandler = memo(
  function WebPushNotificationHandler() {
    useWebPushListeners();
    return null;
  },
);
